import React from "react";

export default function Spinner() {
    return <div className="spinner-border text-success" style={{width: "16rem", height: "16rem"}}
                role="status">
        <span className="sr-only"></span>
    </div>
}